import { createFileRoute, Outlet } from '@tanstack/react-router'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Route = createFileRoute('/_authenticated/companies' as any)({
  component: CompaniesLayout,
})

function CompaniesLayout() {
  return <Outlet />
}
